import React from 'react';
import { motion } from 'framer-motion';
import { Mail } from 'lucide-react';
export function Newsletter() {
  return <section className="py-24 bg-gray-50 border-t border-gray-100" data-id="element-269">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-270">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-16 shadow-sm border border-gray-100 relative overflow-hidden" data-id="element-271">
          {/* Decorative Background Icon */}
          <Mail className="absolute -right-8 -bottom-8 w-64 h-64 text-gray-50 -rotate-12 pointer-events-none" data-id="element-272" />

          <div className="relative z-10 text-center max-w-2xl mx-auto" data-id="element-273">
            <span className="text-gold uppercase tracking-[0.3em] text-[10px] font-bold block mb-4" data-id="element-274">
              Stay Connected
            </span>
            <h2 className="text-3xl md:text-5xl font-serif mb-4 md:mb-6 leading-tight" data-id="element-275">
              Join the TriLyn Circle
            </h2>
            <p className="text-gray-600 mb-8 md:mb-10 text-sm md:text-lg leading-relaxed" data-id="element-276">
              Subscribe to receive updates on new collections, exclusive
              cultural insights, and special offers available only to our
              circle.
            </p>

            <form className="space-y-3 md:space-y-4" onSubmit={e => e.preventDefault()} data-id="element-277">
              <div className="flex flex-col md:flex-row gap-3 md:gap-4" data-id="element-278">
                <input type="text" placeholder="First Name (Optional)" className="flex-1 border border-gray-200 px-6 py-3 md:py-4 focus:outline-none focus:border-gold transition-colors bg-gray-50/50 text-sm" data-id="element-279" />
                <input type="email" required placeholder="Email Address" className="flex-1 border border-gray-200 px-6 py-3 md:py-4 focus:outline-none focus:border-gold transition-colors bg-gray-50/50 text-sm" data-id="element-280" />
              </div>
              <button className="w-full bg-black text-white px-10 py-3 md:py-4 text-xs md:text-sm uppercase tracking-widest font-bold hover:bg-gold transition-all duration-300 shadow-lg hover:shadow-gold/20" data-id="element-281">
                Subscribe to the Circle
              </button>
            </form>

            <p className="mt-6 text-[10px] text-gray-400 uppercase tracking-widest" data-id="element-282">
              By subscribing, you agree to our Privacy Policy and Terms of
              Service.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}